import React from 'react';
import styled from 'styled-components/macro';
import { Button } from '@material-ui/core';
import { translations } from '../../../../locales/translations';
import { useTranslation } from 'react-i18next';

export const AcknowledgeButton = props => {
  const { openDialog, readOnly } = props;
  const { t } = useTranslation();

  const handleOnClick = () => {
    openDialog(true);
  };

  return (
    <Wrapper>
      <Button
        className="ack-btn"
        variant="contained"
        disabled={readOnly}
        onClick={() => handleOnClick()}
      >
        {t(translations.contractDetail.contractInformation.acknowledge)}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  float: right;
  margin-right: 10px;
  .ack-btn {
    color: ${p => p.theme.buttonFont};
    background: ${p => p.theme.buttonColor};
    width: 110px;
    font-size: 12px;
    padding: 5px;
    height: 30px;
  }
`;
